module.exports = __webpack_public_path__ + "img/program.20984222.png";